export default{
    SIMPLE_SAVE : (state, data) => {
        state[data[0]] = data[1]
    },
    SAVE_OBJECT : (state, data) => {
        state[data[0]][data[1]] = data[2]
    },
    PUSH_MESSAGE : (state, data) => {
        if(!state.messages){
            state.messages = []
        }
        state.messages.push(data)
    },
    NEW_MESSAGE : (state, data) => {
        state.newMessages = state.newMessages + 1
    },
    DELETE_NEW_MESSAGE : (state, data) => {
        state.newMessages = 0
    },
    SET_FEEDBACK_ITEM : (state, objectItem) => {
        state.feedback[objectItem.itemName] = objectItem.itemData
    },
    PUSH_FEEDBACK_ITEM : (state, objectItem) => {
        state.feedback[objectItem.itemName].push(objectItem.itemData)
    },
    REMOVE_FEEDBACK_ITEM : (state, objectItem) => {
        let index = state.feedback[objectItem.itemName].indexOf(objectItem.itemData)
        state.feedback[objectItem.itemName].splice(index, 1)
    }
}